import md5 from 'blueimp-md5'

import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  images: {}
}

const uploadFormApplovalActions = generateActions('personProfile/formApproval/UPLOAD')
const approvalActions = generateActions('personProfile/personApproval')

//action-creator для загрузки изображения формы согласия
export const uploadImageForm = createAction(
  API_CONST,
  (file, onUploadProgress) => ({
    file,
    method: 'POST',
    actions: uploadFormApplovalActions,
    url: `auth/uploadImage`,
    options: { onUploadProgress }
  })
)

//action-creator для отправки данных формы согласия на сервер 
export const sendApprovalForm = createAction(API_CONST, (data = {}) => ({
    method: 'POST',
    params: { ...data },
    actions: approvalActions,
    url: `auth/person/agreement`
  }))

export const clearImges = createAction('profile/image/CLEAR')

export default handleActions({
    [clearImges]: state => ({ ...initial }),
    [uploadFormApplovalActions[1]]: (state, { payload }) => {
    return {
        ...state,
        images: {
            ...state.images,
            ...payload.reduce((obj, item) => {
                obj[md5(item.name)] = item
                return obj
            }, {})
        }
    }}
  }, initial)


// WEBPACK FOOTER //
// ./src/store/reducers/profile/personApprovalForm.js